import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function removeCseFromEnrollment(enrollmentId: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.removeCse.url, { id: enrollmentId }))
    .post()
}
